import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ca',
  months: [
    'Gener',
    'Febrer',
    'Març',
    'Abril',
    'Maig',
    'Juny',
    'Juliol',
    'Agost',
    'Setembre',
    'Octubre',
    'Novembre',
    'Desembre',
  ],
  monthsShort: ['Gen', 'Feb', 'Mar', 'Abr', 'Maig', 'Juny', 'Jul', 'Ag', 'Set', 'Oct', 'Nov', 'Des'],
  weekdays: ['Diumenge', 'Dilluns', 'Dimarts', 'Dimecres', 'Dijous', 'Divendres', 'Dissabte'],
  weekdaysMin: ['Dg', 'Dl', 'Dt', 'Dc', 'Dj', 'Dv', 'Ds'],
  weekdaysShort: ['Dg', 'Dl', 'Dt', 'Dc', 'Dj', 'Dv', 'Ds'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD.MM.YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M',
    ll: 'D MMM [de] YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM [de] YYYY, h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'H:mm ([GMT]Z)',
    'LLL+to': 'D MMMM [de] YYYY, H:mm ([GMT]Z)',
  },
  meridiem: { am: 'a. m.', pm: 'p. m.', AM: 'a. m.', PM: 'p. m.' },
  past: {
    y: { one: 'fa %s any', other: 'fa %s anys' },
    M: { one: 'fa %s mes', other: 'fa %s mesos' },
    w: { one: 'fa %s setm.', other: 'fa %s setm.' },
    d: { one: 'fa %s dia', other: 'fa %s dies' },
    h: { one: 'fa %s h', other: 'fa %s h' },
    m: { one: 'fa %s min', other: 'fa %s min' },
    s: { one: 'fa %s s', other: 'fa %s s' },
  },
  future: {
    y: { one: 'd’aquí a %s any', other: 'd’aquí a %s anys' },
    M: { one: 'd’aquí a %s mes', other: 'd’aquí a %s mesos' },
    w: { one: 'd’aquí a %s setm.', other: 'd’aquí a %s setm.' },
    d: { one: 'd’aquí a %s dia', other: 'd’aquí a %s dies' },
    h: { one: 'd’aquí a %s h', other: 'd’aquí a %s h' },
    m: { one: 'd’aquí a %s min', other: 'd’aquí a %s min' },
    s: { one: 'd’aquí a %s s', other: 'd’aquí a %s s' },
  },
  abbr: {
    y: { one: '%s any', other: '%s anys' },
    M: { one: '%s mes', other: '%s mesos' },
    w: { one: '%s set', other: '%s set' },
    d: { one: '%s d', other: '%s d' },
    h: { one: '%s h', other: '%s h' },
    m: { one: '%s min', other: '%s min' },
    s: { one: '%s s', other: '%s s' },
  },
  justNow: 'Ara mateix',
  yesterday: 'Ahir',
  today: 'Avui',
  tomorrow: 'Demà',
  weekStart: 1,
};
const localeName: LocaleName = 'ca';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'a. m.' : 'a. m.';
    } else {
      return isLowerCase ? 'p. m.' : 'p. m.';
    }
  },
};
